export default "__VITE_ASSET__b5c2fd61__"